// extracted by mini-css-extract-plugin
export default {"container":"style_container__RnGVu","header":"style_header__XJ5WM","body":"style_body__gK2Hd","body_expand":"style_body_expand__3ljGS"};